// iter825 — POS device identity + heartbeat (feeds Settings → POS Devices).
import api from '@/lib/api';
import { isKioskEnabled, setKioskEnabled } from '@/lib/kioskLock';

const ID_KEY = 'smarto_device_id';

export function getDeviceId() {
  try {
    let id = localStorage.getItem(ID_KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() || `dev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
      localStorage.setItem(ID_KEY, id);
    }
    return id;
  } catch { return 'unknown'; }
}

function detectShell() {
  const ua = navigator.userAgent || '';
  if (window.Capacitor || /\bwv\b/.test(ua)) return 'android_app';
  if (window.matchMedia?.('(display-mode: standalone)').matches || window.navigator?.standalone === true) return 'pwa';
  return 'browser';
}

export async function sendPosHeartbeat() {
  try {
    const hasAuth = localStorage.getItem('token') || localStorage.getItem('cashier_token');
    if (!hasAuth) return;
    const { data } = await api.post('/cashier/devices/heartbeat', {
      device_id: getDeviceId(),
      branch_id: localStorage.getItem('pos_terminal_branch_id') || null,
      kiosk_enabled: isKioskEnabled(),
      shell: detectShell(),
    });
    // SEC — the server revoked this terminal: end the POS session immediately
    // and bounce to the cashier login (which will itself reject the revoked
    // device). An admin must clear the revoke in Settings → POS Devices.
    if (data?.revoked) {
      try {
        localStorage.removeItem('cashier_token');
        localStorage.removeItem('cashier_user');
        localStorage.removeItem('kitchen_auth');
      } catch { /* ignore */ }
      if (!/\/cashier\/login/.test(window.location.pathname)) {
        window.location.href = '/cashier/login';
      }
      return;
    }
    // iter826 — apply a remote kiosk override from Settings → POS Devices,
    // then ack immediately so the server clears the pending flag.
    const ov = data?.kiosk_override;
    if (ov === 'on' && !isKioskEnabled()) {
      setKioskEnabled(true);
      await api.post('/cashier/devices/heartbeat', { device_id: getDeviceId(), branch_id: localStorage.getItem('pos_terminal_branch_id') || null, kiosk_enabled: true, shell: detectShell() });
    } else if (ov === 'off' && isKioskEnabled()) {
      setKioskEnabled(false);
      await api.post('/cashier/devices/heartbeat', { device_id: getDeviceId(), branch_id: localStorage.getItem('pos_terminal_branch_id') || null, kiosk_enabled: false, shell: detectShell() });
    }
  } catch { /* heartbeat is best-effort */ }
}

// Call from POS screens; returns a cleanup function.
export function startPosHeartbeat() {
  sendPosHeartbeat();
  const handle = setInterval(sendPosHeartbeat, 2 * 60 * 1000);
  return () => clearInterval(handle);
}
